import React, { useState } from 'react';

import { Dialog as MuiDialog, DialogContent } from '@mui/material';
import { makeStyles } from '@mui/styles';

import ReportPopup, { DialogTitle } from './reports/ReportCommonPopup';

import { LoadingIndicator } from './reports/reconcilationreport/MuiStyled';

const useStyles = makeStyles(() => ({
    dialogheader: {
        minHeight: 28,
        textAlign: 'center',
        fontSize: '0.75rem',
        '& span': {
            fontWeight: 'bold'
        },
        '& .modelheader': {
            paddingBottom: '5px',
            fontWeight: 'bold'
        }
    },
    formdialogheader: {
        minHeight: 28,
        fontSize: '0.75rem',
        '& span': {
            fontWeight: 'bold'
        },
        '& .modelheader': {
            paddingBottom: '5px',
        }
    },
}));
const Dialog = ({
    isOpen,
    updateDialogStatus,
    title,
    dialogContent,
    popupGridData,
    popupColumns,
    enablePagination = true,
    isLoading = false,
    customRowHeight,
    dialogTitleClassName = "",
    isForm= false,
    customWidth,
    customHeight,
    dialogContentSx = {},
    alertMinimizedHeight = false,
}) => {
    const classes = useStyles();
    const [dialogState, setDialogState] = useState("minimized");
    const onMinimize = () => {
        setDialogState("minimized");
    }
    const onMaximize = () => {
        setDialogState("maximized");
    }
    return (
        <MuiDialog open={isOpen} maxWidth={false} fullWidth={true} PaperProps={{
            style: {
                width: dialogState === "minimized" ? (customWidth || "860px") : "100%",
                maxWidth: dialogState === "minimized" ? (customWidth || "860px") : "100%",
                height: dialogState === "minimized" ? (alertMinimizedHeight ? ("527px") : (customHeight || "470px")) : "100%",
                maxHeight: dialogState === "minimized" ? (alertMinimizedHeight ? ("527px") : (customHeight || "470px")) : "100%"
            }
        }}>
            <DialogTitle classes={{
                root: dialogTitleClassName
            }}
                dialogState={dialogState}
                onClose={() => { updateDialogStatus(false) }}
                onMinimize={onMinimize}
                onMaximize={onMaximize}
                isForm={isForm}
            >
                <div className={isForm ? classes.formdialogheader :classes.dialogheader}>
                    {title}
                </div>
            </DialogTitle>
            <DialogContent sx={dialogContentSx}>
                {isLoading && <LoadingIndicator />}
                {dialogContent || (<ReportPopup
                    customRowHeight={customRowHeight}
                    enablePagination={enablePagination}
                    modelData={popupGridData}
                    columns={popupColumns} />)}

            </DialogContent>
        </MuiDialog>
    )
}
export default Dialog;